const config = {
    apiBaseUrl: process.env.REACT_APP_API_URL,
    fileServerUrl: process.env.REACT_APP_FILEMGR_URL,
    HeaderKey: "G3)1KQh8dW{}5rhWiZtsz_p[K]9!t9wvM!!QOua6Bb;dL@.FX;+xIuInN!Ux{!d,-Gs8($Jasz{76fM@XI>)A{{%iat9FyU^;k%mlxkbd8AR(]v8IoFb=3KbP}M5u:@u"
};

export default config;
